export const types = {
  STORE_PREVIOUS_LOCATION: 'STORE_PREVIOUS_LOCATION',
  STORE_CURRENT_LOCATION: 'STORE_CURRENT_LOCATION',
};

export const storePreviousLocation = pathname => ({
  type: types.STORE_PREVIOUS_LOCATION,
  payload: {
    pathname,
  },
});
export const storeCurrentLocation = pathname => ({
  type: types.STORE_CURRENT_LOCATION,
  payload: {
    pathname,
  },
});

const INIT_STATE = {
  previous: '/',
  current: '/',
  inapp: '',
  partnerCode: undefined,
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case types.STORE_PREVIOUS_LOCATION:
      return {
        ...state,
        previous: action.payload.pathname,
      };
    case types.STORE_CURRENT_LOCATION:
      return {
        ...state,
        current: action.payload.pathname,
      };
    default:
      return state;
  }
};

export default reducer;

export const getPreviousRoute = state => state.location.previous;
export const getCurrentRoute = state => state.location.current;
export const getIsInapp = state => state.location.inapp === 'true';
export const getPartnerCode = state => state.location.partnerCode;



// WEBPACK FOOTER //
// ./app/redux/location.js